'use client';
import { invalidateSubscriptionQueries } from '#pplx/frontend/apps/ask/queries/upsell-queries/invalidateSubscriptionQueries.js';
import { refreshSubscriptionStatus } from '#pplx/frontend/apps/ask/queries/user-queries/refreshSubscriptionStatus.js';
import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
import { useQueryClient } from '@tanstack/react-query';
import React, { useLayoutEffect, useRef } from 'react';
const StripeStatusRefresher = React.memo(function StripeStatusRefresher() {
    const reason = 'stripe-wrapper';
    const queryClient = useQueryClient();
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const isStripeCheckout = searchParams?.get('stripe_checkout');
    const isReferralStatus = searchParams?.get('referral_status');
    const isEnterprise = useIsEnterpriseUser();
    // Prevent duplicate checkout-return side effects if session-backed deps change
    // before the Stripe return query params are removed.
    const hasHandledStripeCheckoutReturn = useRef(false);
    useLayoutEffect(() => {
        if (!BUILD_CAPABILITIES.payments || hasHandledStripeCheckoutReturn.current)
            return;
        // Skip individual subscription refresh for enterprise users — their org
        // subscription is refreshed separately by useOrgRefreshSubscription.
        if (isEnterprise)
            return;
        if (!isStripeCheckout && !isReferralStatus)
            return;
        hasHandledStripeCheckoutReturn.current = true;
        refreshSubscriptionStatus({ reason }).finally(() => {
            invalidateSubscriptionQueries(queryClient);
            if (isStripeCheckout) {
                return;
            }
            const nextParams = new URLSearchParams(searchParams?.toString() ?? '');
            nextParams.delete('stripe_checkout');
            nextParams.delete('referral_status');
            const query = nextParams.toString();
            router.replace(query ? `${pathname}?${query}` : pathname, 'StripeStatusRefresher cleanup');
        });
    }, [
        isStripeCheckout,
        isReferralStatus,
        isEnterprise,
        queryClient,
        pathname,
        router,
        searchParams,
    ]);
    return null;
});
export default StripeStatusRefresher;
//# sourceMappingURL=StripeStatusRefresher.js.map